import { createSelector } from 'reselect';
import { getPrice } from '../reducer';

const getListingIsFree = createSelector([getPrice], price => price === 0);

export { getListingIsFree };
